import PropTypes from 'prop-types';

// material-ui
import { Typography, Tooltip, Box } from '@mui/material';

// third-party
import { format } from 'date-fns';
import { FormattedMessage, useIntl } from 'react-intl';

// ==============================|| RENDER RECURRENCE SETTINGS ||============================== //

const RenderRecurSettingsGridCell = ({ value }) => {
    const intl = useIntl();

    if (!value) return <Box />;

    const { recurrenceType, expirationType, expiresAtTime, expiresAtRecCount } = value;

    return (
        <Tooltip
            title={
                <Typography variant="inherit" color="inherit">
                    <>
                        {recurrenceType && (
                            <>
                                {`${intl.formatMessage({ id: 'entity-workmgmt-recursettings-recurrencetype' })}: ${intl.formatMessage({
                                    id: `ui-comp-form-recurrencetype-${recurrenceType?.toLowerCase() || 'none'}`
                                })}`}
                                <br />
                            </>
                        )}
                        {expirationType === 'byExpTime' && expiresAtTime && (
                            <>
                                {`${intl.formatMessage({ id: 'entity-workmgmt-recursettings-expirationtype' })}: ${intl.formatMessage({
                                    id: `ui-comp-form-expirationtype-${expirationType?.toLowerCase()}`
                                })}`}
                                <br />
                                {`${intl.formatMessage({ id: 'entity-workmgmt-recursettings-expiresattime' })}: ${format(
                                    new Date(expiresAtTime),
                                    'd/MM/yyyy HH:mm'
                                )}`}
                            </>
                        )}
                        {expirationType === 'byRecCount' && expiresAtRecCount && (
                            <>
                                {`${intl.formatMessage({ id: 'entity-workmgmt-recursettings-expirationtype' })}: ${intl.formatMessage({
                                    id: `ui-comp-form-expirationtype-${expirationType?.toLowerCase()}`
                                })}`}
                                <br />
                                {`${intl.formatMessage({ id: 'entity-workmgmt-recursettings-expiresatreccount' })}: ${expiresAtRecCount}`}
                            </>
                        )}
                        {expirationType === 'none' && <FormattedMessage id="ui-comp-form-expirationtype-none" />}
                    </>
                </Typography>
            }
        >
            <Typography color="inherit" variant="inherit">
                <FormattedMessage id={`ui-comp-form-recurrencetype-${recurrenceType?.toLowerCase() || 'none'}`} />
            </Typography>
        </Tooltip>
    );
};

RenderRecurSettingsGridCell.propTypes = {
    value: PropTypes.object
};

export default RenderRecurSettingsGridCell;
